module.exports = __webpack_public_path__ + "img/check-icon.cbbe07cc.svg";